<div class="toast-wrapper">
    @for (msg of toastService.messages(); track msg) {
        <div
            class="toast"
            [class.success]="msg.severity === 'success'"
            [class.info]="msg.severity === 'info'"
            [class.warn]="msg.severity === 'warn'"
            [class.error]="msg.severity === 'error'"
        >
            <div class="icon">
                @if (msg.severity === 'success') {
                    <span>✔</span>
                }
                @if (msg.severity === 'info') {
                    <span>ℹ</span>
                }
                @if (msg.severity === 'warn') {
                    <span>⚠</span>
                }
                @if (msg.severity === 'error') {
                    <span>✖</span>
                }
            </div>

            <div class="content">
                <div class="summary">{{ msg.summary }}</div>

                @if (msg.detail) {
                    <div class="detail">{{ msg.detail }}</div>
                }
            </div>

            <button class="close-btn" (click)="toastService.remove(msg)">✕</button>
        </div>
    }
</div>
